import React from 'react'
import { Icon, Table } from 'semantic-ui-react'
import { AbbreviatedProduct, AbbreviatedProductContainer } from '../../consts'

interface CurrentQueueProps {
  cart: AbbreviatedProductContainer
  removeFromCart: (id: number) => void
  isLoading?: boolean
}

const CurrentQueue = (props: CurrentQueueProps) => {
  function getProductRow(ap: AbbreviatedProduct) {
    return (
      <Table.Row className="bulk-editor-cart-row" key={ap.id}>
        <Table.Cell>{ap.name}</Table.Cell>
        <Table.Cell>{ap.brand}</Table.Cell>
        <Table.Cell>{ap.id}</Table.Cell>
        <Table.Cell disabled={props.isLoading}>
          <Icon
            data-testid="bulk-editor-cart-trash-icon"
            name="trash alternate outline"
            onClick={() => props.removeFromCart(ap.id)}
          />
        </Table.Cell>
      </Table.Row>
    )
  }

  return (
    <Table collapsing>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Name</Table.HeaderCell>
          <Table.HeaderCell>Brand</Table.HeaderCell>
          <Table.HeaderCell>ID</Table.HeaderCell>
          <Table.HeaderCell>Delete</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {Object.values(props.cart).map((ap: AbbreviatedProduct) => getProductRow(ap))}
      </Table.Body>
    </Table>
  )
}

export default CurrentQueue
